/**
 * @generated SignedSource<<6a357436d29e1dbb900a42a2f8dd117d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchablePublishedRootTable_Query$variables = {};
export type searchablePublishedRootTable_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"searchablePublishedRootTable_QueryFragment">;
};
export type searchablePublishedRootTable_Query = {
  response: searchablePublishedRootTable_Query$data;
  variables: searchablePublishedRootTable_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "searchablePublishedRootTable_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "searchablePublishedRootTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "searchablePublishedRootTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v0/*: any*/),
                "concreteType": "LearnOpportunitiesV2Connection",
                "kind": "LinkedField",
                "name": "SearchLearnOpportunityV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunitiesV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnOpportunityV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "SearchLearnOpportunityV2(first:20)"
              },
              {
                "alias": null,
                "args": (v0/*: any*/),
                "filters": [
                  "titleMatchRegex"
                ],
                "handle": "connection",
                "key": "searchablePublishedRootTable_SearchLearnOpportunityV2",
                "kind": "LinkedHandle",
                "name": "SearchLearnOpportunityV2"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eb5686f82bc2afea22339d664a720eaf",
    "id": null,
    "metadata": {},
    "name": "searchablePublishedRootTable_Query",
    "operationKind": "query",
    "text": "query searchablePublishedRootTable_Query {\n  ...searchablePublishedRootTable_QueryFragment\n}\n\nfragment searchablePublishedRootTable_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n}\n\nfragment searchablePublishedRootTable_QueryFragment on Query {\n  Admin {\n    LearnV2 {\n      SearchLearnOpportunityV2(first: 20) {\n        edges {\n          node {\n            ...searchablePublishedRootTable_LearnOpportunityV2Fragment\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "826ccbf260dc27c93e7888a410343201";

export default node;
